<template>
  <div class="card mb-10 shadow" v-bind:class="{ expanded : expanded  }" @click="expanded = !expanded">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'card',
  data() {
    return {
      expanded: false
    }
  }
}
</script>

<style>
.card {
  background-color: white;
  padding: 15px;
  overflow: hidden;
}
.bidhistory,
.card__collapsed {
  max-height: 0;
  transition: transform 850ms, opacity 450ms;
  transform: translateY(15px);
  opacity: 0;
  overflow: hidden;
}
.card:not(.expanded) .card__collapsed {
  margin: 0 !important;
}
.card.expanded .bidhistory,
.card.expanded .card__collapsed {
  max-height: none;
  opacity: 1;
  transform: translateY(0);
}
</style>
